import React from "react";

export function Badge({ label, cls, dot, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-wide uppercase px-2 py-0.5 rounded border ${cls}`}
    >
      {dot && <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />}
      {label}
    </span>
  );
}

export function StatusBadge({ map, value, testId }) {
  const s = map[value] || { label: value || "-", cls: "bg-slate-100 text-slate-600 border-slate-300", dot: "bg-slate-400" };
  return <Badge label={s.label} cls={s.cls} dot={s.dot} testId={testId} />;
}
